import { getSessionAuthentication, rms2BasePath } from '../common/Api';

// Mirrors the RMS2 SalesComparisonResponse (the backend computes the whole report; this view renders it).
export interface ComparisonCell {
    display: string;
    sign?: 'pos' | 'neg' | 'neu' | null;
    star?: boolean;
    title?: string;
}

export interface ComparisonRow {
    // current | previous | outcome | forecast | remain
    style: string;
    label: string;
    cells: ComparisonCell[];
}

export interface ComparisonSection {
    title: string;
    rows: ComparisonRow[];
}

export interface ComparisonColumn {
    header: string;
    // comparableStore | comparableTotal | nonComparableStore | nonComparableTotal | grandTotal
    kind: string;
    separator: string; // "" | s-ct | s-nc | s-nt | s-gt
    stars: number;
}

export interface SalesComparison {
    period: string;          // week | month
    current: boolean;
    receiptMode: string;     // all | pos
    label: string;
    isComplete: boolean;
    daysElapsed: number;
    daysTotal: number;
    currentYear: number;
    previousYear: number;
    hasBudget: boolean;
    hasVisitors: boolean;
    columns: ComparisonColumn[];
    sections: ComparisonSection[];
}

export async function getSalesComparison(
    period: string,
    current: boolean,
    receiptMode: string,
): Promise<SalesComparison> {
    const auth = getSessionAuthentication();
    const query = new URLSearchParams({ period, current: String(current), receiptMode });

    const response = await fetch(`${rms2BasePath}analytics/sales/comparison?${query}`, {
        method: 'GET',
        headers: {
            'Content-Type': 'application/json',
            'Authorization': auth.token,
            'x-cleverapps-tenant': auth.tenantStringIdentifier,
        },
    });

    if (!response.ok) {
        throw new Error(`Sales comparison failed: ${response.status} ${response.statusText}`);
    }

    return response.json();
}
